import {materialReserveState} from "../MaterialReserveState";

export const ReservationMaterialTableFilterData = [
    {
        "idFromColumnFilter": "materialArticleNumber",
        "id": "materialArticleNumber",
    },
    {
        "idFromColumnFilter": "materialName",
        "id": "materialName",
    },
    {
        "idFromColumnFilter": "quantity",
        "id": "quantity",
    },
    {
        "idFromColumnFilter": "availabilityQuantity",
        "id": "availabilityQuantity",
    },
    {
        "idFromColumnFilter": "orderedQuantity",
        "id": "orderedQuantity",
    },
    {
        "idFromColumnFilter": "needToOrderQuantity",
        "id": "needToOrderQuantity",
    },
    {
        "idFromColumnFilter": "quantityInStock",
        "id": "quantityInStock",
    },
    {
        "idFromColumnFilter": "supplierName",
        "id": "supplierName"
    },
    {
        "idFromColumnFilter": "size",
        "id": "size",
    },
    {
        "idFromColumnFilter": "note",
        "id": "note",
    },
    {
        "idFromColumnFilter": "plans",
        "id": "plans",
    },
    {
        "idFromColumnFilter": "optimizationName",
        "id": "optimizationName"
    },
    {
        "idFromColumnFilter": "arrivalName",
        "id": "arrivalName"
    },
    {
        "idFromColumnFilter": "materialReserveState",
        "id": "materialReserveState",
        "filterFn": (value, filterValue) => materialReserveState[value]?.toLowerCase().includes(filterValue.toLowerCase())
    },
    {
        "idFromColumnFilter": "orderNumbers",
        "id": "orderNumbers"
    },
    {
        "idFromColumnFilter": "arrivalDate",
        "id": "arrivalDate",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },]